<template>
  <div>
    <BaseBrIndex type="invalid" />
  </div>
</template>

<script>
import BaseBrIndex from './index.vue';

export default {
  components: { BaseBrIndex }
};
</script>

<style lang="less" scoped>

</style>
